<div class="insurance-banner-wrapper">
  <button
    *ngIf="userLang && LINK_TARGET"
    class="banner-wrapper"
    (click)="openTargetInNewPage()"
    (keydown.enter)="openTargetInNewPage()"
    (keydown.space)="openTargetInNewPage(); $event.preventDefault()"
    [attr.aria-labelledby]="'insurance-banner-slogan'"
    [class.fix-ru]="userLang === 'ru'"
    [class.fix-uk]="userLang === 'uk'"
    [class.fix-en]="userLang === 'en'"
    [class.fix-pl]="userLang === 'pl'">
    <span id="insurance-banner-slogan" class="sr-only" [innerHTML]="'INSURANCE_BANNER.SLOGAN' | translate"> </span>

    <div class="row space-around" inert>
      <div class="slogan-container" [innerHTML]="'INSURANCE_BANNER.SLOGAN' | translate"></div>
      <img src="https://kartapobytu.app/img/597-trimmed.png" alt="" class="bg-container" />
    </div>
    <div *ngIf="deviceTypeDetected === 'DESKTOP' || deviceTypeDetected === 'TABLET'" class="row align-center" inert>
      <div class="disclaimer-container" [innerHTML]="'INSURANCE_BANNER.DISCLAIMER' | translate"></div>
    </div>
  </button>
  <div *ngIf="deviceTypeDetected === 'PHONE'" class="row align-center">
    <div class="disclaimer-container" [innerHTML]="'INSURANCE_BANNER.DISCLAIMER' | translate"></div>
  </div>
</div>
